import { memo } from 'react'
import { MasterSelector } from 'redux/selector';
import OptionMessage from '../OptionMessage';

const ReceiveMethodMessage = (props) => {
  return <OptionMessage {...props} selector={MasterSelector.receiveMethodOptions} />
}

export default memo(ReceiveMethodMessage);